import React from 'react'
import { i18nTranslate } from 'src/utils'
import { BsFillExclamationCircleFill } from 'react-icons/bs'

class CreditCardExpiryInfo extends React.Component {
  render() {
    const {
      isCardExpired = false,
      isCardExpiringSoon = false,
      cardType = 'CREDITCARD',
    } = this.props
    const expiryText =
      cardType?.toLowerCase() === 'creditcard'
        ? i18nTranslate('payment.ccExpiryText', 'Credit card expiring soon')
        : i18nTranslate('payment.dcExpiryText', 'Debit card expiring soon')

    const expiredText =
      cardType?.toLowerCase() === 'creditcard'
        ? i18nTranslate('payment.ccExpiredText', 'Credit card expired')
        : i18nTranslate('payment.dcExpiredText', 'Debit card expired')

    return (
      <span className="cc-expiry-info">
        {(isCardExpired || isCardExpiringSoon) && (
          <BsFillExclamationCircleFill
            size="1rem"
            className={`tick-icon red`}
          />
        )}
        {isCardExpired
          ? `${expiredText}`
          : isCardExpiringSoon
          ? `${expiryText}`
          : ''}
      </span>
    )
  }
}

export default CreditCardExpiryInfo
export { CreditCardExpiryInfo }
